import React from 'react';
import { Link } from 'react-router-dom';
import { WWW_HOST } from '../const';

const NotFound = props => {
  return (
    <div className="cms cms--public">
      <div className="cms__content cms__404">
        <h1 className="on-boarding__h3">404</h1>
        <h2 className="on-boarding__h1">This doesn't Look Right</h2>

        <p className="p">Let us help you find the right place.</p>

        <a
          href={`//${WWW_HOST}/contact`}
          className="a--blue --new-line p--pad-top"
        >
          Contact Us
        </a>
        <a
          href={`//${WWW_HOST}/faqs`}
          className="a--blue --new-line p--pad-top"
        >
          FAQ
        </a>
        <a
          href={`//${WWW_HOST}/about`}
          className="a--blue --new-line p--pad-top"
        >
          About Us
        </a>
        <Link to="/new-client" className="a--blue --new-line p--pad-top">
          Sign Up
        </Link>
        <Link to="/login" className="a--blue --new-line p--pad-top">
          Sign In
        </Link>
      </div>
    </div>
  );
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js